module.exports = __webpack_public_path__ + "img/bcc015.a97acb7f.jpeg";